import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { Box, Checkbox, FormControlLabel } from '@mui/material'
import Datepicker from '../../../common/datePicker'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../common/dropDownOA'
import LineInputV3 from '../../../common/lineInputV3'
import { ReportHeading } from '../common/ReportHeading'
import LuggageModificationReportTable from './LuggageModificationReportTable'
import moment from 'moment'
import { connect } from 'react-redux'
import { GetLRDetailsForPopUpV2Data, getLuggageModificationReportData } from '../../../../store/reports/reports_action'
import LuggageModel from './LuggageModel'
import { appendToUrl, isEmpty, removeDuplicatesFromArray } from '../../../common/helper'
import { getFtlBkngBranchList } from '../../../../store/common/common_action'
import * as urls from '../oldReportsUrls'
const LuggageModificationReport = (props) => {
  const {
    data: { common, reports, branchAndUserMasterReducer },
    getFtlBkngBranchList,
    getLuggageModificationReportData,
    GetLRDetailsForPopUpV2Data,
    updateAlertError,
    updateModal,
  } = props
  const { loginData, showModal, modalType, companySettings } = common
  const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports
  const { BranchDetailsList } = branchAndUserMasterReducer
  const { lagguageModificationReportData, lrDetailsPopupData } = reports
  const reportName = 'Luggage Modification'
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [lrSearchCheck, setLrSearchCheck] = useState(false)
  const [showModel, setShowModel] = useState(false)
  const [tableData, setTableData] = useState([])
  const [branchList, setBranchList] = useState([])
  const [branchListData, setBranchListData] = useState([])
  const [selBranch, setSelBranch] = useState('')
  const [showTable, setShowTable] = useState(false)
  const [lRInput, setLRInput] = useState('')
  useEffect(() => {
    if (!lrSearchCheck) {
      setLRInput('')
    }
  }, [lrSearchCheck])
  useEffect(() => {
    if (branchList?.length > 0 && loginData) {
      const branches = branchList.map((record) => ({
        BranchID: record.BranchID,
        BranchName: record.BranchName,
      }))
      setBranchListData(branches)
      const defaultBranch = branches.find((branch) => branch.BranchID === loginData.intBranchID)
      setSelBranch(defaultBranch || branches[0])
    }
  }, [branchList, loginData])

  useEffect(() => {
    let data = []
    data = lagguageModificationReportData?.map((val) => ({ ...val }))
    let TotalItemsOld = 0
    let TotalItemsNew = 0
    let TotalFreightOld = 0
    let TotalFreightNew = 0
    let TotalDocumentChargesOld = 0
    let TotalDocumentChargesNew = 0
    let TotalServiceTaxAmountOld = 0
    let TotalServiceTaxAmountNew = 0
    let TotalInsuranceOld = 0
    let TotalInsuranceNew = 0
    let TotalDeliveryChargesOld = 0
    let TotalDeliveryChargesNew = 0
    let TotalCollectionChargesOld = 0
    let TotalCollectionChargesNew = 0
    let TotalCartageAmountOld = 0
    let TotalCartageAmountNew = 0
    let TotalNetAmountOld = 0
    let TotalNetAmountNew = 0
    let TotalCommissionOld = 0
    let TotalCommissionNew = 0
    let TotalDemurrageChgOld = 0
    let TotalDemurrageChgNew = 0
    let TotalHamaliChargesOld = 0
    let TotalHamaliChargesNew = 0
    data?.map((val) => {
      TotalItemsOld += Number(val.ItemsOld)
      TotalItemsNew += Number(val.ItemsNew)
      TotalFreightOld += Number(val.FreightOld)
      TotalFreightNew += Number(val.FreightNew)
      TotalDocumentChargesOld += Number(val.DocumentChargesOld)
      TotalDocumentChargesNew += Number(val.DocumentChargesNew)
      TotalServiceTaxAmountOld += Number(val.ServiceTaxAmountOld)
      TotalServiceTaxAmountNew += Number(val.ServiceTaxAmountNew)
      TotalInsuranceOld += Number(val.InsuranceOld)
      TotalInsuranceNew += Number(val.InsuranceNew)
      TotalDeliveryChargesOld += Number(val.DeliveryChargesOld)
      TotalDeliveryChargesNew += Number(val.DeliveryChargesNew)
      TotalCollectionChargesOld += Number(val.CollectionChargesOld)
      TotalCollectionChargesNew += Number(val.CollectionChargesNew)
      TotalCartageAmountOld += Number(val.CartageAmountOld)
      TotalCartageAmountNew += Number(val.CartageAmountNew)
      TotalNetAmountOld += Number(val.NetAmountOld)
      TotalNetAmountNew += Number(val.NetAmountNew)
      TotalCommissionOld += Number(val.CommissionOld)
      TotalCommissionNew += Number(val.CommissionNew)
      TotalDemurrageChgOld += Number(val.DemurrageChgOld)
      TotalDemurrageChgNew += Number(val.DemurrageChgNew)
      TotalHamaliChargesOld += Number(val.HamaliChargesOld)
      TotalHamaliChargesNew += Number(val.HamaliChargesNew)
    })
    data?.push({
      LRNO: `Total`,
      ItemsOld: TotalItemsOld,
      ItemsNew: TotalItemsNew,
      FreightOld: TotalFreightOld,
      FreightNew: TotalFreightNew,
      DocumentChargesOld: TotalDocumentChargesOld,
      DocumentChargesNew: TotalDocumentChargesNew,
      ServiceTaxAmountOld: TotalServiceTaxAmountOld,
      ServiceTaxAmountNew: TotalServiceTaxAmountNew,
      InsuranceOld: TotalInsuranceOld,
      InsuranceNew: TotalInsuranceNew,
      DeliveryChargesOld: TotalDeliveryChargesOld,
      DeliveryChargesNew: TotalDeliveryChargesNew,
      CollectionChargesOld: TotalCollectionChargesOld,
      CollectionChargesNew: TotalCollectionChargesNew,
      CartageAmountOld: TotalCartageAmountOld,
      CartageAmountNew: TotalCartageAmountNew,
      NetAmountOld: TotalNetAmountOld,
      NetAmountNew: TotalNetAmountNew,
      CommissionOld: TotalCommissionOld,
      CommissionNew: TotalCartageAmountNew,
      DemurrageChgOld: TotalDemurrageChgOld,
      DemurrageChgNew: TotalDemurrageChgNew,
      HamaliChargesOld: TotalHamaliChargesOld,
      HamaliChargesNew: TotalHamaliChargesNew,
      isTotal: true,
      IsRefund: 0,
    })
    setTableData(data || [])
  }, [lagguageModificationReportData])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      let BranchBody = {
        intUserID: loginData.intUserID,
        intCompanyID: loginData.intCompanyID,
        intCityID: 0,
        intBookingBranchID: -1,
      }
      getFtlBkngBranchList(BranchBody)
        .then((res) => {
          if (res.status === 'Success') {
            setBranchList(res?.Data?.Table)
          } else {
            setBranchList([])
          }
        })
        .catch((err) => {
          console.log('Error:', err)
        })
    }
  }, [loginData])
  const handleClick1 = () => {
    setShowTable(true)
    if (!lrSearchCheck) {
      const obj = {
        CompanyID: loginData.intCompanyID,
        dtDateFrom: moment(fromDate).format('YYYY-MM-DD'),
        dtDateTo: moment(toDate).format('YYYY-MM-DD'),
        FromBranchId: selBranch?.BranchID,
        LRNo: '',
        Mode: 0,
        BookingID: 0,
      }
      getLuggageModificationReportData(obj)
    } else {
      const obj2 = {
        strLRNO: lRInput,
        intCompanyID: loginData.intCompanyID,
        intBranchID: loginData.intBranchID,
        intUserID: loginData.intUserID,
        intBranchCityID: loginData.intBranchCityID,
      }
      GetLRDetailsForPopUpV2Data(obj2)
      setShowModel(true)
    }
  }
  const handleClose = () => {
    setShowModel(false)
  }
  const handleClick2 = () => {
    let url = urls.lugguageModificationReport
    let urlData = urls.lugguageModificationReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.dtDateFrom = fromDate.format('DD-MMM-YYYY')
    urlData.dtDateTo = toDate.format('DD-MMM-YYYY')
    urlData.FromBranchId = selBranch?.BranchID
    urlData.FromBranch = selBranch?.BranchName
    urlData.LRNo = 0
    urlData.BookingID = 0
    urlData.intAllowExportToExcel = 1
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsxGrow} style={{ width: '5%' }} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={'From Date'}
              id={'fromDate'}
              dateChange={(date) => {
                setFromDate(date)
                setShowTable(false)
                // focusElemnt(id.toDate)
              }}
              width="100%"
              dateDiff={730}
            />
          </Item>
          <Item sx={sx.itemsxGrow} style={{ width: '5%' }} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Date'}
              value={toDate}
              id={'toDate'}
              dateChange={(date) => {
                setToDate(date)
                setShowTable(false)
                // focusElemnt("goodGoBtn")
              }}
              width="100%"
              dateDiff={730}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'fromBranch'}
              label={'From Branch'}
              searchPlaceholder={`Search Selected From Branch`}
              defaultvalue={selBranch?.BranchName || ''}
              data={removeDuplicatesFromArray(branchListData, 'BranchID') || []}
              listWidth="230px"
              dataKey={`BranchName`}
              idKey={`BranchID`}
              disabled={lrSearchCheck}
              // onSelect={(obj) => { setSelSelectedCity(obj); setShowTable(false) }}
              onSelect={(obj) => {
                setSelBranch(obj)
                setShowTable(false)
              }}
              // nextId={id.gbSourceBranch}
              prevId={'goodGoBtn'}
              width="350px"
            />
          </Item>
          <Box sx={{ display: 'inline-flex', padding: '0% 0px', height: '40px' }}>
            <FormControlLabel
              value="end"
              control={
                <Checkbox
                  id="LRSearch"
                  checked={lrSearchCheck}
                  onChange={() => {
                    setLrSearchCheck(!lrSearchCheck)
                  }}
                />
              }
              label={'LR Search?'}
              labelPlacement="end"
            />
          </Box>
          <Item className="input--wrapper" sx={sx.itemsx}>
            <LineInputV3
              // onKeyDown={(e) => {
              //     navigation1(e, 'memoDeliveryReceiverPhone', 'memoTablerowCheck0')
              // }}
              id="memoDeliveryReceiver"
              label="LR No."
              value={lRInput}
              onBlur={(e) => setLRInput(e.target.value)}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ cursor: 'pointer' }}>
            {/* <Item sx={sx.itemsx} style={{ cursor: "pointer" }} onKeyDown={(e)=>navigation3(e,showTable?disableExcel?"ExportToPdf":"ExportToExl":id.fromDate,id.anReportOptions,()=>handleClick1())}> */}
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={true}
              // id1={id.reportmainButton}
              // prevID={id.summaryCheck}
              onClick1={handleClick1}
              onClick2={handleClick2}
            />
          </Item>
        </Box>
      </Item>
      {showTable ? (
        <LuggageModificationReportTable
          fromDate={fromDate}
          toDate={toDate}
          tableData={tableData}
          selBranch={selBranch}
          lRInput={lRInput}
          UseFormattedLRinReports={UseFormattedLRinReports}
        />
      ) : null}
      {showModel && lrSearchCheck ? (
        <LuggageModel
          updateModal={handleClose}
          lrDetailsPopupData={lrDetailsPopupData}
          setTableData={setTableData}
          setShowModel={setShowModel}
          fromDate={fromDate}
          toDate={toDate}
          selBranch={selBranch}
          lRInput={lRInput}
        />
      ) : null}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getLuggageModificationReportData, GetLRDetailsForPopUpV2Data, getFtlBkngBranchList }
export default connect(mapStateToProps, mapDispatchToProps)(LuggageModificationReport)
